import React, { useState, useEffect } from "react";
import { FaBars, FaXmark } from "react-icons/fa6";
import { Link, NavLink, useLocation } from "react-router-dom";
import ChangeLanguageDropdown from "../../commons/Language/Language";
import { useTranslation } from "react-i18next";

// Every page of the site renders this header, so the site stylesheets load here:
// template base first, then the mobile-first layer that overrides it.
import "../assets/css/main.css";
import "../KeysHome.css";

const NAV_ITEMS = [
  { to: "/keys-company", key: "key-company-navitems.item1", exact: true },
  { to: "/keys-company-uberuns", key: "key-company-navitems.item2" },
  { to: "/keys-company-kontakt", key: "key-company-navitems.item3" },
  { to: "/keysimpressum", key: "key-company-navitems.item4" },
  { to: "/keysdatenschutzerklarung", key: "key-company-navitems.item5" }
];

const DESKTOP_QUERY = "(min-width: 1200px)";

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 100);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close the menu after navigating.
  useEffect(() => setMenuOpen(false), [location.pathname]);

  // While the phone menu is open: lock page scroll, close on Escape or when the
  // viewport grows to the desktop layout.
  useEffect(() => {
    if (!menuOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = e => e.key === "Escape" && setMenuOpen(false);
    const mql = window.matchMedia(DESKTOP_QUERY);
    const onChange = e => e.matches && setMenuOpen(false);
    document.addEventListener("keydown", onKey);
    mql.addEventListener?.("change", onChange);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", onKey);
      mql.removeEventListener?.("change", onChange);
    };
  }, [menuOpen]);

  return (
    <header
      id="header"
      className={`site-header fixed-top ${isScrolled ? "sticked" : ""} ${
        menuOpen ? "is-open" : ""
      }`}
    >
      <div className="container-xl site-header__bar">
        <Link to="/" className="site-header__logo">
          <span className="sitename">Schluesseldienst</span>
          <span className="site-header__dot" aria-hidden="true">
            .
          </span>
        </Link>

        <button
          type="button"
          className="site-header__toggle"
          aria-expanded={menuOpen}
          aria-controls="navmenu"
          aria-label={menuOpen ? t("Close menu") : t("Open menu")}
          onClick={() => setMenuOpen(open => !open)}
        >
          {menuOpen ? <FaXmark aria-hidden="true" /> : <FaBars aria-hidden="true" />}
        </button>

        <nav id="navmenu" className="site-nav">
          <ul className="site-nav__list">
            {NAV_ITEMS.map(item => (
              <li key={item.to}>
                <NavLink to={item.to} exact={item.exact} className="site-nav__link">
                  {t(item.key)}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="site-nav__actions">
            <ChangeLanguageDropdown />
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
